module.exports = __webpack_public_path__ + "static/media/messaging.01d73818.svg";